export class CopyLinkButtons {
  constructor(copyButtons) {
    this.$buttons = copyButtons;
    this.$buttons.on("click", this._handleButtonClick.bind(this));
  }

  _handleButtonClick(evt) {
    evt.preventDefault();
    var target =
      evt.target.nodeName !== "A" ? evt.target.parentNode : evt.target;
    this._copyToClipboard(target.href);
    alert("Der Link wurde in die Zwischenablage kopiert");
  }

  _copyToClipboard(value) {
    var tempInput = document.createElement("input");
    tempInput.value = value;
    document.body.appendChild(tempInput);
    tempInput.select();
    document.execCommand("copy");
    document.body.removeChild(tempInput);
  }
}

jQuery(document).ready(function ($) {
  // Copy Link
  var copyButtons = $(".with-copy-link .wp-block-file__button");
  if (copyButtons.length) {
    new CopyLinkButtons(copyButtons);
  }

  // add download attribute
  $(".wp-block-file>a").attr("download", "");
});
